/* eslint-disable */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfigOld = {
  apiKey: "AIzaSyDRqvnzrQ1rfJj0CRosHT-XdBLDJbrN04w",
  authDomain: "project-149825067316332335.firebaseapp.com",
  projectId: "project-149825067316332335",
  storageBucket: "project-149825067316332335.firebasestorage.app",
  messagingSenderId: "1082579834770",
  appId: "1:1082579834770:web:fb41a0fe1caf794df7d34b",
};
const firebaseConfig = {
  apiKey: "AIzaSyCO4uVsOKIWQCTSNotYdV0Sml-Q3asQ2A4",
  authDomain: "lwyr-app.firebaseapp.com",
  projectId: "lwyr-app",
  storageBucket: "lwyr-app.firebasestorage.app",
  messagingSenderId: "1042592462053",
  appId: "1:1042592462053:web:d2398b8c31db15babb100c",
  measurementId: "G-4PVBD3LX96"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase Auth
export const auth = getAuth(app);



///// new to read/write
import { getFirestore } from "firebase/firestore";
export const db = getFirestore(app);

///// Push notifications (Firebase Cloud Messaging)
// getMessaging() throws in environments without the Push API (older Safari,
// SSR, etc), so we feature-detect first and hand back `null` when
// unsupported. Consumers must await this before calling getToken/onMessage.
import { getMessaging, isSupported as isMessagingSupported } from "firebase/messaging";
export const messagingPromise = isMessagingSupported().then((supported) =>
  supported ? getMessaging(app) : null
);
